import src from "IMAGE";
export default { src, width: 641, height: 77, blurWidth: 0, blurHeight: 0};
